<template>
  <div class="ds-manager__table">
    <el-row type="flex" class="r-row ds-manager__component-row">
      <div class="ds-manager__component-subtitle">
        <r-text type="caption">
          {{ $t("ds-manager:table:list-title") }}
        </r-text>
      </div>
      <div class="ds-manager__table-tools">
        <div class="ds-manager__table-tools__item">
          <el-tooltip
            :open-delay="1500"
            :content="`${$t('ds-manager:table:tools:delete-all')}`"
            placement="top"
          >
            <el-button
              circle
              type="danger"
              class="r-button icon-button"
              size="mini"
              @click="beforeDeleteAllAttributes"
              :disabled="!attributes.length"
            >
              <r-icon name="trash" type="additional" :size="16" />
            </el-button>
          </el-tooltip>
        </div>
        <div class="ds-manager__table-tools__item">
          <el-tooltip
            :open-delay="1500"
            :content="`${$t('ds-manager:table:tools:add')}`"
            placement="top"
          >
            <el-button
              @click="addAttribute"
              class="r-button"
              size="mini"
              type="primary"
              :disabled="!addAttributeEnable"
              >{{ $t("ds-manager:table:tools:add") }}</el-button
            >
          </el-tooltip>
        </div>
      </div>
    </el-row>
    <el-row class="r-row ds-manager__component-row">
      <div class="ds-manager__table-wrapper">
        <el-table
          :data="attributes"
          class="r-table simple"
          border
          :cell-class-name="getCellClassName"
          :row-class-name="getRowClassName"
        >
          <el-table-column
            v-for="title in fields"
            :prop="title.prop"
            :label="$t(title.label)"
            :key="title.prop"
          >
            <template slot-scope="scope">
              <el-input
                class="r-input"
                size="mini"
                v-if="title.type === 'string' || title.type === 'name'"
                :disabled="isNotEditabledField(scope.row)"
                v-model="scope.row[title.prop]"
              ></el-input>
              <el-select
                v-else-if="title.type === 'belongs_to'"
                class="r-select"
                size="mini"
                v-model="scope.row[title.prop]"
                :no-match-text="$t('ds-manager:creation:no-match')"
                :disabled="isNotEditabledField(scope.row)"
                filterable
              >
                <el-option
                  v-for="subitem in types"
                  :key="subitem"
                  :label="$t(subitem)"
                  :value="subitem"
                ></el-option>
              </el-select>
              <el-checkbox
                v-else-if="title.type === 'bool'"
                class="r-checkbox"
                :disabled="isNotEditabledField(scope.row)"
                size="mini"
                v-model="scope.row[title.prop]"
              />
              <span v-else-if="title.type === 'datasource'">
                {{ getDsName(scope.row[title.prop], scope.row) }}
              </span>
              <span v-else>{{ scope.row[title.prop] }}</span>
            </template>
          </el-table-column>
          <el-table-column width="70px">
            <template slot-scope="scope">
              <el-tooltip
                :open-delay="1500"
                :content="`${$t('ds-manager:table:tools:delete')}`"
                placement="top"
              >
                <el-button
                  v-if="!isNotEditabledField(scope.row)"
                  circle
                  type="danger"
                  class="r-button icon-button r-table__delete-button"
                  size="mini"
                  @click="beforeDeleteAttribute(scope.row)"
                >
                  <r-icon name="trash" type="additional" :size="16" />
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import isEqual from "lodash.isequal";

export default {
  props: {
    attributes: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => []
    },
    datasourcesList: {
      type: Array,
      default: () => []
    },
    initialAttributes: {
      type: Array,
      default: () => []
    },
    changedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isValid: false
    };
  },
  watch: {
    attributes: {
      handler: function(val) {
        this.isValid = true;
        val
          .map(e => e.title)
          .forEach((x, i, arr) =>
            i !== arr.indexOf(x) || i !== arr.lastIndexOf(x)
              ? (this.isValid = false)
              : ""
          );

        this.$emit("nameValidation", this.isValid);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    addAttributeEnable() {
      if (!this.attributes.length) return true;
      const isTitleEmpty = this.attributes.find(
        e => !e.title || !e.title.trim().length
      );
      const isTypeEmpty = this.attributes.find(
        e => !e.type || !e.type.trim().length
      );

      return !(isTitleEmpty || isTypeEmpty);
    }
  },
  methods: {
    addAttribute() {
      this.$emit("addAttribute");
    },
    getDsName(source_id, row) {
      // get ds name by source_id for table
      if (!source_id) return "-";
      const ds = this.datasourcesList.find(ds => ds.id === source_id);
      if (!ds) return "ИД не найден";
      return `${ds.name} (${row.primary_key})`;
    },
    isNotEditabledField(row) {
      return (
        row["source_name"] === "id" ||
        row["source_name"] === "geom" ||
        row["system_field"] ||
        row["read_only"]
      );
    },
    beforeDeleteAttribute(row) {
      const warningText = `${this.$t("modal.warning_text::delete")}`;
      const warningTitle = `${this.$t("modal.warning_title")}`;
      const confirmButtonText = `${this.$t("modal.confirm_button")}`;
      const cancelButtonText = `${this.$t("modal.cancel_button")}`;
      this.$confirm(warningText, warningTitle, {
        customClass: "r-message-box",
        type: "warning",
        closeOnPressEscape: false,
        closeOnClickModal: false,
        confirmButtonText,
        cancelButtonText
      })
        .then(() => {
          this.deleteAttribute(row);
        })
        .catch(() => {});
    },
    beforeDeleteAllAttributes() {
      const warningText = `${this.$t("modal.warning_text::delete-all")}`;
      const warningTitle = `${this.$t("modal.warning_title")}`;
      const confirmButtonText = `${this.$t("modal.confirm_button")}`;
      const cancelButtonText = `${this.$t("modal.cancel_button")}`;
      this.$confirm(warningText, warningTitle, {
        customClass: "r-message-box",
        type: "warning",
        closeOnPressEscape: false,
        closeOnClickModal: false,
        confirmButtonText,
        cancelButtonText
      })
        .then(() => {
          this.deleteAllAttribute();
        })
        .catch(() => {});
    },
    deleteAttribute(row) {
      if (row["title"] === "id" || row["title"] === "geom") return;
      this.$emit("deleteAttribute", row);
    },
    deleteAllAttribute() {
      this.$emit("deleteAllAttribute");
    },
    nameValidate(currentName, newName) {
      let result = true;
      this.initialAttributes.forEach(e => {
        if (
          (e.source_name === newName && e.source_name !== currentName) ||
          newName.replace(/\s+/g, "") === ""
        ) {
          result = false;
        }
      });
      return result;
    },
    validateName(name) {
      if (!name) return false;
      let matchCount = 0;

      this.attributes.forEach(e => {
        if (e.title) {
          if (e.title.trim() === name.trim()) ++matchCount;
        }
      });

      return matchCount;
    },
    getCellClassName({ row, columnIndex }) {
      if (columnIndex === 0) {
        let nameAvailable;
        if (row.title) {
          nameAvailable = !!(this.validateName(row.title) < 2);
          if (!nameAvailable) return "incorrect";
        } else {
          nameAvailable = false;
        }
      }
    },
    getRowClassName(row) {
      if (this.isNotEditabledField(row.row)) return "not-editable";

      const current = row.row;
      const title = current.source_name;
      const initial = this.initialAttributes.find(item => item.title === title);
      if (!initial) return "row-new";
      for (const prop in initial) {
        const currentValue = current[prop] === "" ? null : current[prop];
        const initialValue = initial[prop] === "" ? null : initial[prop];
        if (
          current[prop] !== undefined &&
          !isEqual(currentValue, initialValue)
        ) {
          if (this.changedRows.indexOf(title) === -1)
            this.$emit("addChangedRow", title);
          return "row-edited";
        }
      }
      const changedIndex = this.changedRows.findIndex(item => item === title);

      if (changedIndex > -1) this.$emit("deleteChangedRow", changedIndex);
    }
  }
};
</script>

<style lang="scss">
.ds-manager__table {
  .el-row--flex {
    justify-content: space-between;
    align-items: center;
    .ds-manager__component-subtitle {
      padding: 0;
    }
  }
  &-tools {
    display: flex;
    justify-content: flex-end;
    &__item {
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .r-table {
    td {
      .cell {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .r-checkbox {
        width: 100%;
        justify-content: center;
      }
      &.incorrect {
        background-color: rgba(var(--accent_error), 0.3) !important;
      }
    }
    .el-table__body-wrapper {
      max-height: 180px;
      overflow-y: auto;
    }
    tr {
      &.not-editable {
        background-color: rgba(var(--black), 0.1) !important;
        label {
          cursor: not-allowed;
        }
        input {
          color: var(--text_secondary) !important;
        }
        &:hover {
          td {
            background-color: rgba(var(--black), 0.1) !important;
          }
        }
      }
      &.row-edited,
      &.row-new {
        background-color: rgba(var(--accent_primary), 0.1) !important;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "ds-manager:table:tools:add": "Добавить новый атрибут",
    "ds-manager:table:tools:delete": "Удалить атрибут",
    "ds-manager:table:tools:delete-all": "Удалить все атрибуты",
    
    "ds-manager:creation:no-match": "Нет совпадений",
    "ds-manager:table:list-title": "Список атрибутов",

    "modal.confirm_button": "Да",
    "modal.cancel_button": "Нет",
    "modal.warning_title": "Предупреждение",
    "modal.warning_text::delete": "Данный атрибут будет удалён без возможности восстановления. Продолжить?",
    "modal.warning_text::delete-all": "Все атрибуты будут удалены без возможности восстановления. Продолжить?",

    "name": "Наименование атрибута",
    "type": "Тип",
    "default": "Значение по умолчанию",
    "datasource": "Источник данных",
    "time field": "Временное поле"
  },
  "en": {
    "ds-manager:table:tools:add": "Add new attribute",
    "ds-manager:table:tools:delete": "Delete attribute",
    "ds-manager:table:tools:delete-all": "Delete all attributes",
    
    "ds-manager:creation:no-match": "No match",
    "ds-manager:table:list-title": "Attributes list",

    "modal.confirm_button": "Yes",
    "modal.cancel_button": "No",
    "modal.warning_title": "Warning",
    "modal.warning_text::delete": "Current attribute will be permanently deleted. Continue?",
    "modal.warning_text::delete-all": "All attributes will be permanently deleted. Continue?",

    "name": "Attribute name",
    "type": "Type",
    "default": "Default value",
    "datasource": "Datasource",
    "time field": "Time field"
  }
}
</i18n>
